import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SelectionSummaryPage } from './selection-summary.page';
import { SubscriptionStopSelectionComponent } from 'src/app/component/subscription-stop-selection/subscription-stop-selection.component';
import { SubscriptionScheduleSelectionComponent } from 'src/app/component/subscription-schedule-selection/subscription-schedule-selection.component';

const routes: Routes = [
  {
    path: '',
    component: SelectionSummaryPage,
  },
];

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, RouterModule.forChild(routes)],
  declarations: [SelectionSummaryPage, SubscriptionStopSelectionComponent, SubscriptionScheduleSelectionComponent],
})
export class SelectionSummaryPageModule {}
